import { set } from "@/utils/vuex";
import Vue from "vue";

export default {
  setLayout: set("processedLayout"),

  // New layout management mutations
  setCurrentLayout: set("currentLayout"),
  setEditingPath: set("editingPath"),
  setAvailableProducts: set("availableProducts"),
  setAvailableColors: set("availableColors"),
  setLayoutAction: set("layoutAction"),

  // Navigation and editing mutations
  navigateToPath(state, path) {
    state.editingPath = [...path];
  },

  navigateUp(state) {
    if (state.editingPath.length > 0) {
      state.editingPath.pop();
    }
  },

  navigateDown(state, index) {
    state.editingPath.push(index);
  },

  // Layout manipulation mutations
  updateLayoutItem(state, { path, item }) {
    let current = state.currentLayout.Objects;

    // Navigate to the parent array
    for (let i = 0; i < path.length - 1; i++) {
      if (!current[path[i]].Objects) {
        Vue.set(current[path[i]], "Objects", []);
      }
      current = current[path[i]].Objects;
    }

    // Update the item using Vue.set for reactivity
    if (path.length > 0) {
      Vue.set(current, path[path.length - 1], { ...item });
    } else {
      // Handle root level update (shouldn't happen in normal flow)
      console.warn("Attempting to update root level item with empty path");
    }
  },

  addLayoutItem(state, { path, item }) {
    let current = state.currentLayout.Objects;

    // Navigate to the correct array
    for (let i = 0; i < path.length; i++) {
      if (!current[path[i]].Objects) {
        Vue.set(current[path[i]], "Objects", []);
      }
      current = current[path[i]].Objects;
    }

    // Use push which is reactive in Vue
    current.push(item || {});

    // Update position properties for all items in the array
    current.forEach((item, index) => {
      if (item && typeof item === "object") {
        Vue.set(item, "position", index + 1);
      }
    });
  },

  removeLayoutItem(state, { path, index }) {
    let current = state.currentLayout.Objects;

    // Navigate to the correct array
    for (let i = 0; i < path.length; i++) {
      if (!current[path[i]].Objects) {
        Vue.set(current[path[i]], "Objects", []);
      }
      current = current[path[i]].Objects;
    }

    // Use splice which is reactive in Vue
    current.splice(index, 1);

    // Update position properties for all remaining items in the array
    current.forEach((item, index) => {
      if (item && typeof item === "object") {
        Vue.set(item, "position", index + 1);
      }
    });
  },

  moveLayoutItem(state, { path, fromIndex, toIndex }) {
    let current = state.currentLayout.Objects;

    // Navigate to the correct array
    for (let i = 0; i < path.length; i++) {
      if (!current[path[i]].Objects) {
        Vue.set(current[path[i]], "Objects", []);
      }
      current = current[path[i]].Objects;
    }

    // Move the item using reactive splice operations
    const item = current.splice(fromIndex, 1)[0];
    current.splice(toIndex, 0, item);

    // Update position properties for all items in the array
    current.forEach((item, index) => {
      if (item && typeof item === "object") {
        Vue.set(item, "position", index + 1);
      }
    });
  },

  setCurrentEvent: set("currentEvent"),
  setCurrentStallHolders: set("currentStallHolders"),
  setCurrentStallholder: set("currentStallholder"),
  setCurrentStalls: set("currentStalls"),
  setCurrentStall: set("currentStall"),
  setCurrentStallTags: set("currentStallTags"),
  // setAllEventsByYear: set('allEventsByYear'),

  setCurrentEventManagementTab: set("currentEventManagementTab"),
  setCurrentProductManagementTab: set("currentProductManagementTab"),

  setEventSelectorDisabled: set("eventSelectorDisabled"),

  // Clear layout state
  clearCurrentLayout(state) {
    state.currentLayout = {
      LayoutId: "",
      LayoutName: "",
      Stalls: [],
      Objects: [],
    };
    state.editingPath = [];
    state.layoutAction = "create";
  },

  resetAdminState(state) {
    state.processedLayout = {};

    // Layout state management
    state.currentLayout = {
      LayoutId: "",
      LayoutName: "",
      Stalls: [],
      Objects: [],
    };
    state.editingPath = [];
    state.availableProducts = [];
    state.availableColors = [];
    state.layoutAction = "create";

    // Backend admin state
    state.currentEvent = {};
    state.currentStallHolders = [];
    state.currentStallholder = {};
    state.currentStalls = [];
    state.currentStall = {};

    state.currentEventManagementTab = "Events";
    state.currentProductManagementTab = "Categories";

    state.eventSelectorDisabled = false;
  },
};
